import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import LandingPage from '@/pages/LandingPage';
import AuthCallback from '@/pages/AuthCallback';
import GoogleCallback from '@/pages/GoogleCallback';
import LoginPage from '@/pages/LoginPage';
import AdminLoginPage from '@/pages/AdminLoginPage';
import PlansPage from '@/pages/PlansPage';
import CorporateCateringPage from '@/pages/CorporateCateringPage';
import Dashboard from '@/pages/Dashboard';
import CorporatePage from '@/pages/CorporatePage';
import FitnessPage from '@/pages/FitnessPage';
import MealsPage from '@/pages/MealsPage';
import ProfilePage from '@/pages/ProfilePage';
import AdminPage from '@/pages/AdminPage';
import WellnessLandingPage from '@/pages/wellness/WellnessLandingPage';
import WellnessMarketplacePage from '@/pages/wellness/WellnessMarketplacePage';
import WellnessProfilePage from '@/pages/wellness/WellnessProfilePage';
import WellnessJoinPage from '@/pages/wellness/WellnessJoinPage';
import MyWellnessPage from '@/pages/wellness/MyWellnessPage';
import WellnessProLoginPage from '@/pages/wellness/WellnessProLoginPage';
import WellnessProDashboardPage from '@/pages/wellness/WellnessProDashboardPage';
import ProtectedRoute from '@/components/ProtectedRoute';

function AppRouter() {
  const location = useLocation();
  
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/plans" element={<PlansPage />} />
      <Route path="/corporate-catering" element={<CorporateCateringPage mode="corporate" />} />
      <Route path="/bulk-orders" element={<CorporateCateringPage mode="bulk" />} />
      <Route path="/wellness" element={<WellnessLandingPage />} />
      <Route path="/wellness/find" element={<WellnessMarketplacePage />} />
      <Route path="/wellness/join" element={<WellnessJoinPage />} />
      <Route path="/wellness/my-wellness" element={<MyWellnessPage />} />
      <Route path="/wellness/pro/login" element={<WellnessProLoginPage />} />
      <Route path="/wellness/pro/dashboard" element={<WellnessProDashboardPage />} />
      <Route path="/wellness/pro/:slug" element={<WellnessProfilePage />} />
      <Route path="/auth/google/callback" element={<GoogleCallback />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/corporate" element={<ProtectedRoute><CorporatePage /></ProtectedRoute>} />
      <Route path="/fitness" element={<ProtectedRoute><FitnessPage /></ProtectedRoute>} />
      <Route path="/ai-nutrition" element={<Navigate to="/wellness/find?category=nutrition" replace />} />
      <Route path="/meals" element={<ProtectedRoute><MealsPage /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute redirectTo="/admin/login" adminOnly><AdminPage /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
